import { type FC } from 'react';

import type { Hit } from '@core/ts/algolia';

import { Card } from '../Card';
import styles from './Results.module.css';

type Props = {
  results: Hit[];
  exactMatchesCount: number;
};

const RelatedResults: FC<Props> = ({ results, exactMatchesCount }) => (
  <ol className={styles.results}>
    {results.map((hit, index) => (
      <li key={hit.program.id}>
        <Card
          dataTestId="related-matches-card"
          key={hit.program.id}
          hit={hit}
          eventingOverrides={{
            customDimensions: [{ key: 'isUserRequested', value: 'false' }],
            product: { location: 'voyager-related-results-page', position: index + 1 + exactMatchesCount },
          }}
        />
      </li>
    ))}
  </ol>
);

export { RelatedResults };
